import { IonCol, IonGrid, IonRow } from '@ionic/react';
import React from 'react';
import { Title } from '../../components/Title';
import { css } from '@emotion/react';

interface BaseSectionProps {
  title?: string;
  children: React.ReactNode;
  compact?: boolean;
}

export const BaseSection: React.FC<BaseSectionProps> = ({ title = null, children, compact = false }) => {
  return (
    <IonGrid css={css(compact ? { padding: 0 } : {})}>
      {title && (
        <IonRow>
          <IonCol>
            <Title level={2}>{title}</Title>
          </IonCol>
        </IonRow>
      )}
      <IonRow>{children}</IonRow>
    </IonGrid>
  );
};
